/**
 * Web Developer Custom Script
 */
jQuery(document).ready(function($) {
  
  /* About us page image slide function */
  $('.img_slider').slick({
    dots: true,
    speed: 300,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: true,
  	autoplaySpeed: 5000,
    arrows: false
  });
  
  
  /* About us page Ambassadors section slide function */
  $('.members_main').slick({
    dots: false,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    arrows: true, 
    responsive: [
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2
        }
      }
    ]
  });
  
  
  /* Product details page - product info tab expand/collapase function */
  $('.tab_header').on('click', function() {
    
    if ( $(this).hasClass('open') ) {
      $(this).removeClass('open');
      $(this).siblings('.tab_content').slideUp(200, function() {
        $(this).parent().removeClass('open');
      });
    } else { 
      $(this).addClass('open');
      $(this).siblings('.tab_content').slideDown(300, function() {
        $(this).parent().addClass('open');
      });
    }
    
  });
  
  
  /* PDP - size fit guide switch function */
  $('.switch_fit li').on('click', function() {
    
    if ( !$(this).hasClass('active') ) {
      $('.switch_fit li').removeClass('active');
      $(this).addClass('active');
      var viewing = $(this).attr('view');      
      $('.fit_content').attr('viewing', viewing);
    }
    
  });
  
  
  /* Product detail page - product images slide function */
  if ( $(window).width() < 768 && $('#product_main').length ) {
    
    $('#product_main .slider-for').slick({
      dots: false,
      speed: 300,
      slidesToShow: 2,
      slidesToScroll: 2,
      autoplay: true,
      autoplaySpeed: 5000,
      arrows: true, 
      responsive: [
        {
          breakpoint: 600,
          settings: {
            slidesToShow: 1,
      		slidesToScroll: 1
          }
        }
      ]
    });
    
  }
  
  
  /* Collection sidebar category filter level 1 click function */
  $('#CollectionFiltersForm .sidebar-link-lv1.dropdown > a').on('click', function(e) {
    
    e.preventDefault();
    $(this).parent().toggleClass('open');
    
  });

  /* Set add to cart button text */
  if (window.location.pathname.startsWith('/fr')) {
    $('#product-add-to-cart.add_to_cart').val('Ajouter au panier');
  } else {
    $('#product-add-to-cart.add_to_cart').val('Add to cart');
  }
  
  
  /* Complete the look proper variant select function */
  $('.look_product-variants .look_swatch-element:not(.color):not(.soldout) label').on('click', function() {
    
    var v_id = $(this).parents().next('input').data('value-sticky');
    $(this).closest('.swatch').siblings('#look1_product-selectors').find('option[value="' + v_id + '"]').prop('selected', true);
    
  });
  
  $('.look_product-variants .look2_swatch-element:not(.color):not(.soldout) label').on('click', function() {
    
    var v_id = $(this).parents().next('input').data('value-sticky');
    $(this).closest('.swatch').siblings('#look2_product-selectors').find('option[value="' + v_id + '"]').prop('selected', true);
    
  });
  
  
  /* Collection page sidebar category parent active function */
  $('#CollectionFiltersForm .sidebar-links ul li.sidebar-link-lv1').each(function() {
    
    if ( $(this).find('a.active').length ) {
      $(this).addClass('par_active');
    }
    
  });
  
  
  /* FAQ accordion expand/collapse function */
  $('.faq_header').on('click', function() {
    
    if ( $(this).parent().hasClass('active') ) {
      $(this).siblings('.faq_content').slideUp(200, function() {
        
      });
      $(this).parent().removeClass('active');
    } else {
      $(this).siblings('.faq_content').slideDown(300, function() {
        
      });
      $(this).parent().addClass('active');
    }
    
  });
  
  
  /* Liberate html scrollable after adding a product to the cart in Quick View mode */
  $('.wrapper-overlay').on('click', function() {
    
    $('html').css('overflow', 'initial');
    
  });
  
  $('.close-cart').on('click', function() {
    
    $('html').css('overflow', 'initial');
    
  });


  /* -------------------------------------------------------
     Complete the Look — inject Quick View buttons
     Runs after DOM ready and watches for late app rendering
  ------------------------------------------------------- */
  function injectQuickViewButtons() {
    $('#complete_look .tab_product').each(function() {
      var $product = $(this);

      // Skip if button already added
      if ($product.find('.qv-btn').length) return;

      // Get product handle from the image link href
      var href = $product.find('a.product-grid-image').attr('href');
      if (!href) return;

      var handle = href.replace('/products/', '').split('?')[0];

      var btnHtml = '<button class="qv-btn" type="button" data-qv-handle="' + handle + '">' +
        '<span>Quick View</span>' +
        '<svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 24 24" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"><path d="M1 12s4-8 11-8 11 8 11 8-4 8-11 8-11-8-11-8z"/><circle cx="12" cy="12" r="3"/></svg>' +
        '</button>';

      $product.find('.look_left').append(btnHtml);
    });
  }

  // Run immediately in case app has already rendered
  injectQuickViewButtons();

  // Also watch for the Bonify app rendering content dynamically
  var observer = new MutationObserver(function() {
    injectQuickViewButtons();
  });
  observer.observe(document.body, { childList: true, subtree: true });

});
/* Collection page - hover image crossfade */
document.addEventListener('DOMContentLoaded', function () {
  document.querySelectorAll('.inner.product-item').forEach(function (item) {
    var json = item.getAttribute('data-json-product');
    if (!json) return;
    var data = JSON.parse(json);
    if (!data.media || data.media.length < 2) return;

    var hoverSrc = data.media[1].src;
    var imageDiv = item.querySelector('.product-image');
    if (!imageDiv) return;

    var hoverImg = document.createElement('img');
    hoverImg.src = 'https:' + hoverSrc.replace(/(_\d+x\d*)?\.jpg/, '_540x.jpg');
    hoverImg.alt = '';
    hoverImg.className = 'hover-image-overlay';
    imageDiv.appendChild(hoverImg);
  });
});